// if coming from another page
// store the hash (DON'T put this code inside the $() function, it has to be executed
// right away before the browser can start scrolling!
var hash = window.location.hash;
if( hash ) {

	// delete hash so the page won't scroll to it
	window.location.hash = "";
	// if coming from another page

}





(function ($, root, undefined) {

	$(function () {

		'use strict';

		// DOM ready, take it away

        if ( sessionStorage ){

        	if ( !sessionStorage.getItem('isshow') ) {

	            $('#topbar_banner').show();
	            sessionStorage.setItem('isshow', 'true');

        	} else if ( sessionStorage.getItem('isshow') === 'true' ) {

	            $('#topbar_banner').show();
	            sessionStorage.setItem('isshow', 'true' );

        	}

        }

		$("span.closebtn").click(function() {
			$('#topbar_banner').hide();
			sessionStorage.setItem('isshow', 'false');
		});

        // Smooth Scroll
		//
		var top_space = 0;

		if( width <= 1023 ) {
			top_space = 0;
		} else {
			top_space = 44;
		}

		function scroll_to( hash, myTimeout ) {

			setTimeout(function(){

				// https://stackoverflow.com/questions/6677035/jquery-scroll-to-element
				$('html, body').animate({
					scrollTop: $(hash).offset().top-top_space
				}, 1000);

			}, myTimeout);

		}


		// If coming from another page.
		if( hash ) {
			scroll_to( hash, 2000 );

		}


		// if already on the page
		$("a[href*='#']:not([href='#'])").click(function(e) {

			var hash = this.hash;

			if ( '#menu' !== hash ) {
				// only slide down if not on mobile and mobile menu button clicked.

				var current_window_location = window.location.href;
				var click_window_location   = $(this).context.origin + $(this).context.pathname;

				if( current_window_location === click_window_location) {
					// We are already on the same page as the clicked button url.

					e.preventDefault();

					if( hash ) {
						scroll_to( hash, 400 );
					}
				}

			}

		});
		// if already on the page
		//
		// Smooth Scroll




		Modernizr.load({
			// Before loading any resource, query the browser with Modernizr extension to check if cssremunit is supported.
			// If the test returns true, yep url is used (in this case nothing is loaded)
			// If the test return false, the nope url is suposed to be a polyfill fallback (in this case rem.min.js)
			test: Modernizr.cssremunit,
			yep : '',
			nope: '/wp-content/themes/bovard/js/lib/rem.min.js',

			callback: function (url, result, key) {
				if (url === '/wp-content/themes/bovard/js/lib/rem.min.js') {
					// console.log("cssremunit not supported fallback to rem.min.js");
				}else{
					// console.log("cssremunit supported");
				}
			}
		});


		var width 	= viewportSize.getWidth();
		var height 	= viewportSize.getHeight();
		displayWidth();


		$( window ).resize(function() {
			width = viewportSize.getWidth();
			height = viewportSize.getHeight();
			displayWidth();

			if( width >= 768 ) {
				stick_header();
				if( $('.equal-heights').length > 0 ) {
					$('.equal-heights').matchHeight();
				}
				if( $('#learning-outcomes .equal-heights-two').length > 0 ) {
					$('#learning-outcomes .equal-heights-two > .vc_column-inner').matchHeight({byRow: false});
				}
			} else {
				$("section.header-menu").unstick();
			}

		});


		function displayWidth() {
			$('.dev-page-width').text(width);
			$('.dev-page-height').text(height);
		}



		$('.fancybox').fancybox();





		if( width >= 768 ) {
			stick_header();

			if( $('.equal-heights').length > 0 ) {
				$('.equal-heights').matchHeight();
			}

			if( $('#learning-outcomes .equal-heights-two').length > 0 ) {
				$('#learning-outcomes .equal-heights-two > .vc_column-inner').matchHeight({byRow: false});
			}

		}

		function stick_header() {
			$("section.header-menu").sticky({ topSpacing: 0 });
		}


		// $("#my-menu").mmenu({
		// 	extensions: ["theme-light", "pagedim-black"],
		// 	offCanvas: {
  		//		position: "right",
  		//		zposition : "next"
		// 	},
		// 	slidingSubmenus: false,
		// 	counters: false,
		// 	dividers: {
		// 		add: false
		// 	},
		// 	navbars: [{
	 	//  	title: "Menu"
	 	//	}]
		// });



		// $( '#nav li:has(ul)' ).doubleTapToGo();




		// $('body').addClass('js');

		var $menu = $('#menu'),
			$menulink = $('.menu-link');

		$menulink.click(function() {
			$menulink.toggleClass('active');
			$menu.toggleClass('active');
			return false;
		});



		if( width >= 1024 ) {
			$( 'nav.nav li:has(ul)' ).doubleTapToGo();
		}



		// http://www.smashingmagazine.com/2011/10/18/how-to-use-ajax-in-wordpress/
		// http://premium.wpmudev.org/blog/load-posts-ajax/
		$.ajaxSetup({cache:false});
		$('.ajax_about').click(function(e) {

			e.preventDefault();

			var url = $('.ajax_about').data('url')+
								'/wp-admin/admin-ajax.php?nounce='+
								$('.ajax_about').data('nounce');

					$.ajax({
						url: 	url,
						type: 	'post',
						data: 	{
							action: 'get_variations',
							nonce: $('.ajax_about').data('nounce'),
							page: $('.ajax_about').data('page')
						},
						success: function( html ) {

							// success message here

							$("footer").html(html)

						},
						error: function() {

							// error message here

						}
					})





		});



	});



	$(window).load(function() {


		// Vertically align icons
		adjustHeight();

		$(window).resize(function() {
			adjustHeight();
		});

		function adjustHeight() {

			if( $('.uavc-list-content .uavc-list-icon img.img-icon').length > 0 ) {

				$(".uavc-list-icon-wrapper").each(function( index ) {

					var $icon 	= $('img.img-icon', this).height();
					var $text 	= $('.uavc-list-desc', this).height();

					if( $text > $icon ) {
						$('img.img-icon', this).css('margin-top', ($text - $icon)/2+'px');
					} else {
						$('.uavc-list-desc', this).css('margin-top', ($icon - $text)/2+'px');
					}

				});

			}

			// if( $('section#lead-photo').length > 0 ) {
			// 	var $li_height 			= $('section#lead-photo img').height();

			// 	if( $li_height > 600 ) {
			// 		$('section#lead-photo img').css('margin-top', -($li_height-600)/2+'px');
			// 	}
			// }

		}

	});

})(jQuery, this);
